export const videoTableColumns = [
  { prop: "thumbnailUrl", label: "缩略图" },
  { prop: "title", label: "标题" },
  { prop: "channelId", label: "频道" },
  { prop: "videoId", label: "视频ID" },
  { prop: "videoUrl", label: "视频播放地址" },
  { prop: "name", label: "名称" },
  { prop: "privacyStatus", label: "状态" },
  { prop: "creatorName", label: "操作人员" },
  { prop: "madeForKid", label: "内容是否面向儿童" },
  { prop: "viewCount", label: "观看次数" },
  { prop: "createTime", label: "入库日期" },
];
